export default class DistributivoProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }

    getAllDistributivo(page, take) {
        return this.axios.get(this.url + `/distributivo?page=${page}&take=${take}`);
    }

    getListaDistributivo() {
        return this.axios.get(this.url + `/distributivo/lista`);
    }

    createDistributivo(params) {
        return this.axios.post(this.url + '/distributivo', params);
    }

    updateDistributivo(id, params) {
        return this.axios.put(this.url + `/distributivo/${id}`, params);
    }

    updateDistributivoProgreso(id, params) {
        return this.axios.put(this.url + `/distributivo/progreso/${id}`, params);
    }

    removeDistributivo(id) {
        return this.axios.delete(this.url + `/distributivo/${id}`);
    }

    activateDistributivo(id, state) {
        return this.axios.put(this.url + `/distributivo/activate/${id}?state=${state}`);
    }
    
    async queryDistributivo(querys) {
        return await this.axios.get(this.url + `/distributivo/query?querys=${querys}`);
    }
    
    // ==================================TUTORES DE CURSO ===============================================
    getAllTutores(page, take) {
        return this.axios.get(this.url + `/tutores?page=${page}&take=${take}`);
    }

    createTutores(params) {
        return this.axios.post(this.url + '/tutores', params);
    }

    getListaTutores() {
        return this.axios.get(this.url + `/tutores/lista`);
    }
    getTutorById(id) {
        return this.axios.get(this.url + `/tutores/${id}`);
    }
    getTatuById(id) {
        return this.axios.get(this.url + `/tutores/tatu/${id}`);
    }
    getTutorReportesById(id) {
        return this.axios.get(this.url + `/tutores/rep/${id}`);
    }
    updateTutores(id, params) {
        return this.axios.put(this.url + `/tutores/${id}`, params);
    }
    updateTutoresInfo(id, params) {
        return this.axios.put(this.url + `/tutores/info/${id}`, params);
    }
    updateTutoresInfoFin(id, params) {
        return this.axios.put(this.url + `/tutores/infoFin/${id}`, params);
    }

    removeTutores(id) {
        return this.axios.delete(this.url + `/tutores/${id}`);
    }

    async queryTutores(querys) {
        return await this.axios.get(this.url + `/tutores/query?querys=${querys}`);
    }

    /*Rutoas para los proyectos interdisiplinarios */

    getListaProyecto() {
        return this.axios.get(this.url + `/proyecto/lista`);
    }

    getProyectoById(id) {
        return this.axios.get(this.url + `/proyecto/${id}`);
    }

    createProyecto(params) {
        return this.axios.post(this.url + '/proyecto', params);
    }

    updateProyecto(id, params) {
        return this.axios.put(this.url + `/proyecto/${id}`, params);
    }

    updateProyectoNotas(id, params) {
        return this.axios.put(this.url + `/proyecto/notas/${id}`, params);
    }

    removeProyecto(id) {
        return this.axios.delete(this.url + `/proyecto/${id}`);
    }


    /*Rutoas para los proyectos interdisiplinarios */

    getListaProducto() {
        return this.axios.get(this.url + `/producto/lista`);
    }

    getProductoById(id) {
        return this.axios.get(this.url + `/producto/${id}`);
    }

    createProducto(params) {
        return this.axios.post(this.url + '/producto', params);
    }

    updateProducto(id, params) {
        return this.axios.put(this.url + `/producto/${id}`, params);
    }

    updateProductoNotas(id, params) {
        return this.axios.put(this.url + `/producto/notas/${id}`, params);
    }

    removeProducto(id) {
        return this.axios.delete(this.url + `/producto/${id}`);
    }
    
}